const venueTemplate = require('../../templates').venueTemplate;
const roomTemplate = require('../../templates').roomTemplate;

const venueData = Object.assign({}, venueTemplate, {
	id: 'escape-history-house',
	name: 'Escape History House',	
	website: 'https://www.escapehistory.dk',
	locations: [
		{
			id: 'oksbol',
			cityId: 'oksbol',
			opened: '20180730',
			closed: null,
			address: 'Baunhøjvej 38, 6840 Oksbøl',
			coordinates: {lat: '55.638555', lng: '8.281601'},
		},
		{
			id: 'blaavand',
			cityId: 'blaavand',
			opened: '20251001',
			closed: null,
			address: 'Tane Hedevej 32, 6857 Blåvand',
			coordinates: {lat: '55.553021', lng: '8.142380'},
		},
		{
			id: 'aarhus',
			cityId: 'aarhus',
			opened: '20260206',
			closed: null,
			address: 'Klostergade 82, 8000 Aarhus',
			coordinates: {lat: '56.158547', lng: '10.202769'},
		}
	],
	rooms: [
		Object.assign({}, roomTemplate, {
			id: 'escape-land-of-mine',
			name: {da: '1945', en: '1945'},			
			languages: ['da', 'en', 'de'],
			minimumAge: 8,
			minimumAgeNoAdult: 18,
			difficulty: 50,
			locations: [{
				locationId: 'oksbol',
				opened: '20190701',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'escape-tirpitz',
			name: {da: 'Tirpitz', en: 'Tirpitz'},
			languages: ['da', 'en', 'de'],
			minimumAge: 8,
			minimumAgeNoAdult: 18,
			difficulty: 50,
			locations: [{
				locationId: 'oksbol',
				opened: '20180730',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'illuminati-cabin',
			name: {da: 'Illuminati Hytte', en: 'Illuminati Cabin'},
			languages: ['da', 'en', 'de'],
			minutes: 1200,
			teamSizeMax: 4,
			minimumAge: 15,
			minimumAgeNoAdult: 18,
			difficulty: 75,
			heart: 'gold',
			locations: [{
				locationId: 'oksbol',
				opened: '20210701',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'sabotage',
			name: {da: 'Sabotage', en: 'Sabotage'},
			languages: ['da', 'en', 'de'],
			minutes: 90,
			teamSizeMin: 4,
			teamSizeMax: 48,
			minimumAge: 12,
			tagIds: ['live-actors'],
			locations: [{
				locationId: 'oksbol',
				opened: '20240912',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'hannibal',
			name: {da: 'Operation Hannibal', en: 'Operation Hannibal'},
			languages: ['da', 'en', 'de'],
			minutes: 120,
			teamSizeMin: 2,
			teamSizeMax: 8,
			minimumAge: 12,
			minimumAgeNoAdult: 18,
			tagIds: ['live-actors'],
			locations: [{
				locationId: 'oksbol',
				opened: '20250401',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'murder-mystery',
			name: {da: 'Murder Mystery', en: 'Murder Mystery'},
			languages: ['da', 'en', 'de'],
			minutes: 150,
			teamSizeMin: 2,
			teamSizeMax: 4,
			difficulty: 80,
			locations: [{
				locationId: 'oksbol',
				opened: '20250801',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'viking',
			name: {da: 'Viking', en: 'Viking'},
			languages: ['da', 'en', 'de'],
			minutes: 70,
			teamSizeMin: 2,
			teamSizeMax: 6,
			minimumAge: 8,
			difficulty: 60,
			locations: [{
				locationId: 'blaavand',
				opened: '20251001',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'hex',
			name: {da: 'Hex', en: 'Hex'},
			languages: ['da', 'en', 'de'],
			minutes: 60,
			teamSizeMin: 2,
			teamSizeMax: 6,
			minimumAge: 8,
			locations: [{
				locationId: 'blaavand',
				opened: '99999999',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'dmitri-donskoy',
			name: {da: 'Dmitri Donskoy', en: 'Dmitri Donskoy'},
			languages: ['da', 'en', 'de'],
			minutes: 75,
			teamSizeMin: 2,
			teamSizeMax: 6,
			minimumAge: 8,
			locations: [{
				locationId: 'aarhus',
				opened: '20260206',
				closed: null,
				rooms: 1
			}]
		}),
		Object.assign({}, roomTemplate, {
			id: 'regan-vest',
			name: {da: 'Regan Vest', en: 'Regan Vest'},
			languages: ['da', 'en', 'de'],
			minutes: 75,
			teamSizeMin: 2,
			teamSizeMax: 6,
			minimumAge: 8,
			locations: [{
				locationId: 'aarhus',
				opened: '20260511',
				closed: null,
				rooms: 1
			}]
		})

	]
});


export {venueData};